<template>
  <v-dialog v-model="dialog" @keydown.esc="cancel" width="400">
    <v-card>
      <v-toolbar dense flat>
        <v-toolbar-title>{{ options.title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">{{ options.message }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click.native="cancel">{{ options.cancelButtonText }}</v-btn>
        <v-btn color="primary darken-1" text @click.native="save">{{
          options.saveButtonText
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Confirm',
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    options: {
      message: '',
      title: 'vi',
      saveButtonText: 'Ok',
      cancelButtonText: 'Avbryt',
    },
  }),

  methods: {
    open(options) {
      this.options = { ...this.options, ...options }
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    save() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
  },
}
</script>
<style lang="less" scoped></style>
